import React from "react";
import AppRoutes from "./AppRoutes";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
